



























import { EmployeeNode } from '@/models';
import Vue, { PropType } from 'vue';
import EmployeeChartNode from './EmployeeChartNode.vue';
export default Vue.extend({
  name: 'EmployeeChartContainer',

  components: { EmployeeChartNode },

  props: {
    trees: {
      type: Array as PropType<EmployeeNode[]>,
      default: () => []
    }
  },

  computed: {
    treeHasNodes(): boolean {
      return this.trees.length > 0;
    }
  }
});
